import { render, staticRenderFns } from "./politica-de-entrega.vue?vue&type=template&id=3b0740f0&"
import script from "./politica-de-entrega.vue?vue&type=script&lang=js&"
export * from "./politica-de-entrega.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports